import { AssignedClaim } from 'containers/CourtManagerAssignedClaims/typings';
import { rcCoporeal } from 'containers/CourtManagerLegalProceedings/constants';
import { get, isEmpty, uniq } from 'lodash';
import { PAGES } from 'routes';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import messages from 'containers/ManagerHomePage/messages';
import { CLAIM_STATUS } from 'containers/data-structure';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { OPENING_STATE } from 'services/constants';

export const formatAssignedClaims = (
  assignedClaims: AssignedClaim[],
  isCourtMonitoringOrOpeningManager: boolean,
) => {
  if (!isEmpty(assignedClaims.filter((el: any) => get(el, 'responseSagis')))) {
    if (
      !isEmpty(
        assignedClaims.filter(
          (el: any) =>
            !isEmpty(
              get(el, 'responseSagis.offeredRisks', []).find(
                (c: any) => c.riskName === rcCoporeal,
              ),
            ),
        ),
      )
    ) {
      return [
        ...constructClaimToDisplayBasicManagement([
          get(assignedClaims, '[0].responseSagis', {}),
        ]),
      ];
    } else {
      return [];
    }
  }
  if (
    !isEmpty(
      assignedClaims.filter((el: any) => !isEmpty(get(el, 'corpoResult', []))),
    ) &&
    !isEmpty(
      assignedClaims.filter(
        (el: any) =>
          !isEmpty(
            get(el, 'VcResult', []).filter((item: any) => !isEmpty(item)),
          ),
      ),
    )
  ) {
    return [
      ...get(assignedClaims, '[0].corpoResult', []),
      ...constructClaimToDisplayBasicManagement(
        get(assignedClaims, '[0].VcResult', []),
      ),
    ];
  }
  if (
    !isEmpty(
      assignedClaims.filter((el: any) => !isEmpty(get(el, 'corpoResult', []))),
    )
  ) {
    return [...get(assignedClaims, '[0].corpoResult', [])];
  }
  if (
    !isEmpty(
      assignedClaims.filter(
        (el: any) =>
          !isEmpty(
            get(el, 'VcResult', []).filter((item: any) => !isEmpty(item)),
          ),
      ),
    )
  ) {
    return [
      ...constructClaimToDisplayBasicManagement(
        get(assignedClaims, '[0].VcResult', []),
      ),
    ];
  }
  if (!isCourtMonitoringOrOpeningManager) {
    const formattedClaims: any[] = [];
    if (
      isEmpty(
        assignedClaims.filter((el: any) => el.assignedLawyer && !el.isDeleted),
      )
    )
      return [];
    assignedClaims
      .filter((el: any) => el.assignedLawyer && !el.isDeleted)
      .forEach((el: any) => {
        if (!formattedClaims.find((item: any) => item.claimId === el.claimId)) {
          const foundClaims = assignedClaims.filter(
            (item: any) => item.claimId === el.claimId,
          );
          formattedClaims.push({
            ...el,
            assignedLawyers: uniq([
              ...foundClaims.map((item: any) => item.assignedLawyer),
              el.assignedLawyer,
            ]),
          });
        }
      });
    return formattedClaims;
  } else {
    return assignedClaims;
  }
};
export const renderUrlByProfile = (
  isCourtMonitoringManager: boolean,
  isConsultationManager: boolean,
  isOpeningManager: boolean,
  isTransactionManager: boolean,
  claimId: number,
  status: string,
  openingState: string,
) => {
  if (isCourtMonitoringManager && status === CLAIM_STATUS.VALIDATED) {
    return `${PAGES.COURT_MONITORING_MANAGER_LEGAL_PROCEEDINGS}/${claimId}`;
  } else if (isConsultationManager) {
    return `${PAGES.CONSULTATION_LEGAL_PROCEEDING_PAGE}/${claimId}`;
  } else if (isOpeningManager) {
    return `${PAGES.MANAGER_RECAP_PAGE}/${claimId}`;
  } else if (isTransactionManager && status === CLAIM_STATUS.VALIDATED) {
    return `${PAGES.TRANSACTION_LEGAL_PROCEDDING}/${claimId}`;
  } else if (
    (status === CLAIM_STATUS.REJECTED ||
      status === CLAIM_STATUS.PENDING ||
      status === CLAIM_STATUS.PENDING_INFO_MODIFICATION ||
      status === CLAIM_STATUS.PENDING_APPROVAL ||
      (!isCourtMonitoringManager &&
        openingState === OPENING_STATE.NOT_COMPLETED)) &&
    (isCourtMonitoringManager ||
      isConsultationManager ||
      userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) ||
      isTransactionManager)
  ) {
    return `${PAGES.CONSULTATION_LEGAL_PROCEEDING_PAGE}/${claimId}`;
  } else {
    return `${PAGES.COURT_MANAGER_LEGAL_PROCEEDINGS}/${claimId}`;
  }
};

export const renderClaimStatus = (status: string) => {
  switch (status) {
    case CLAIM_STATUS.VALIDATED:
      return messages.validated;
    case CLAIM_STATUS.PENDING:
      return messages.pending;
    case CLAIM_STATUS.REJECTED:
      return messages.rejected;
    case CLAIM_STATUS.PENDING_INFO_MODIFICATION:
      return messages.pendingInfoClaim;
    case CLAIM_STATUS.PENDING_APPROVAL:
      return messages.validatedCorpo;
  }
};

export const constructClaimToDisplayBasicManagement = (claims: any) => {
  if (!isEmpty(claims)) {
    return claims.map((el: any) => ({
      ...el,
      nature: get(el, 'claimType'),
      claimNumber: get(el, 'code'),
      lossHour: get(el, 'lossTime'),
      isBasicManagement:
        featureService.hasFeature(FEATURES.BASIC_MANAGEMENT) ||
        featureService.hasFeature(FEATURES.BASIC_MANAGEMENT_REGULATION),
    }));
  } else {
    return [];
  }
};

export const filterEmptyResult = (result: any) => {
  return result.filter((el: any) => !isEmpty(el));
};
